import { Injectable } from '@angular/core';
import { AngularFirestore } from '@angular/fire/compat/firestore';

import { Council, CouncilData } from './data/council.data';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CouncilService {

  dioceses = ['Cincinnati', 'Cleveland', 'Columbus', 'Steubenville', 'Toledo', 'Youngstown'];
  councils: Council[] = CouncilData.councils;

  constructor(private firestore: AngularFirestore) { }

  getCouncils(): Council[] {
    return this.councils;
  }

  getCouncilById(id: number): Council {
    return this.councils.find(c => Number(c.id) === id);
  }

  getDioceseById(id: number): string {
    if (id > 0 && id <= this.dioceses.length) {
      return this.dioceses[id - 1];
    }
    return '';
  }

  // createCouncils() {
  //   return new Promise<any>((resolve, reject) => {
  //     const batch = this.firestore.firestore.batch();

  //     const councilsCol = this.firestore.firestore.collection('councils');
  //     this.councils.forEach((val) => {
  //       const councilDoc = councilsCol.doc();
  //       batch.set(councilDoc, val);
  //     });

  //     batch.commit().then(res => {}, err => reject(err));
  //   });
  // }
}
